import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { KeyValuePair, SelectListOption } from '../../shared/shared.types';
import { ReflectionService } from '../../shared/utilities/reflection.service';

@Component({
    selector: 'app-multiple-select-output',
    templateUrl: './multiple-select-output.component.html',
    styleUrls: ['./multiple-select-output.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class MultipleSelectOutputComponent implements OnInit, OnDestroy {
    private subscription: Subscription;

    constructor(private reflection: ReflectionService) {}

    @Input() observableItems: Observable<Array<SelectListOption>>;
    @Input() selectItems: Array<SelectListOption>;
    @Input() control: UntypedFormControl;
    @Input() asInfo: boolean;
    @Input() keyValuePairs: Array<KeyValuePair>;
    @Input() selectedValues: string[];

    ngOnInit(): void {
        if (this.control) {
            this.selectedValues = this.control.value;
            this.control.valueChanges.subscribe((value) => {
                this.selectedValues = value;
            });
        }
        if (this.observableItems) {
            this.subscription = this.observableItems.subscribe((next: Array<SelectListOption>) => {
                this.selectItems = next;
            });
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    getTextValue(selected: string) {
        if (this.selectItems && this.selectItems.length) {
            return this.selectItems.find((option) => option.value === selected)?.text;
        }
        if (this.keyValuePairs && this.keyValuePairs.length) {
            return this.keyValuePairs.find((kvp) => kvp.key === selected)?.value;
        }
        return selected;
    }

    getAllText(selectedValues: string[]): string {
        if (selectedValues && selectedValues.length) {
            return (
                'Selected Values: ' +
                this.reflection.toEnglishSentence(Array.from(new Set(selectedValues.map((m) => this.getTextValue(m)))))
            );
        }
    }
}
